import { render, staticRenderFns } from "./CreateEventModal.vue?vue&type=template&id=3415117a&scoped=true&"
import script from "./CreateEventModal.vue?vue&type=script&lang=ts&"
export * from "./CreateEventModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415117a",
  null
  
)

export default component.exports